import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { getSession } from '../store/auth'

export const withAuthGuard = (Component) => (props) => {
  const { isAuthed } = useSelector(getSession)

  if (!isAuthed) {
    return <Redirect to="/auth/login" />
  }

  return <Component {...props} />
}

export const withUnauthGuard = (Component) => (props) => {
  const { isAuthed } = useSelector(getSession)

  if (isAuthed) {
    return <Redirect to="/secure" />
  }

  return <Component {...props} />
}
